import { render } from "./UserManagementDashboard.vue?vue&type=template&id=57f5c7d7&scoped=true"
import script from "./UserManagementDashboard.vue?vue&type=script&lang=js"
export * from "./UserManagementDashboard.vue?vue&type=script&lang=js"

import "./UserManagementDashboard.vue?vue&type=style&index=0&id=57f5c7d7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f5c7d7"]])

export default __exports__